import { useEffect, useRef } from 'react';

const useOutsideClick = (callback, additionalConditions, options) => {
    const mergedAdditionalConditions = additionalConditions ?? true;
    const insideRef = useRef();
    const outsideRef = useRef();

    const onOutsideClick = ({ target }) => {
        if (mergedAdditionalConditions) {
            if (
                outsideRef.current &&
                outsideRef.current.contains(target) &&
                insideRef.current &&
                !insideRef.current.contains(target)
            ) {
                return callback();
            }
            if (!outsideRef.current && insideRef.current && !insideRef.current.contains(target)) {
                return callback();
            }
        }
        return null;
    };
    useEffect(() => {
        document.addEventListener('click', onOutsideClick, options);
        return () => {
            document.removeEventListener('click', onOutsideClick, options);
        };
    });
    return [insideRef, outsideRef];
};

export default useOutsideClick;
